import { NavLink, Outlet, useNavigate } from "react-router-dom";

const tabClass = ({ isActive }) =>
  `px-4 py-2 text-sm font-medium rounded-lg transition ${
    isActive ? "bg-indigo-600 text-white shadow-sm" : "text-slate-600 hover:bg-slate-100"
  }`;

export default function PayrollRunsLayout() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50">
      <div className="border-b border-slate-200 bg-white">
        <div className="w-full max-w-full min-w-0 px-4 sm:px-6 py-4">
          <div className="flex flex-wrap items-center justify-between gap-3 mb-4">
            <div>
              <h1 className="text-xl sm:text-2xl font-semibold text-slate-900">Payroll runs</h1>
              <p className="text-sm text-slate-500 mt-0.5">
                Browse pay periods, run history, amounts, and employee breakdowns.
              </p>
            </div>
            <button
              type="button"
              onClick={() => navigate("/payrollhome")}
              className="text-sm text-slate-600 hover:text-slate-900 px-3 py-1.5 rounded-lg border border-slate-200 bg-white"
            >
              ← Payroll home
            </button>
          </div>
          <nav className="flex gap-2">
            <NavLink to="/payroll-runs" end className={tabClass}>
              History &amp; details
            </NavLink>
            <NavLink to="/payroll-runs/new" className={tabClass}>
              Create new run
            </NavLink>
          </nav>
        </div>
      </div>
      <Outlet />
    </div>
  );
}
